import { DateUtil } from '@/utils';
import mutations from './gridSampleMutation';
import actions from './gridSampleAction';
import getters from './gridSampleGetter';

const state = {
  cnt: 0,
  gridData: {},
  searchParam: {
    divisionCode: '', // 사업부
    cspCode: '', // CSP
    accoutId: '', // Linked Account
    keyAge: '', // Key Age
    batchDate: null, // 조회일자
    keyExcept: '', // 보안조치
  },
  item: {},
  projectList: [],
};

export default {
  state,
  mutations,
  actions,
  getters,
  DateUtil,
};



// WEBPACK FOOTER //
// ./src/vuex/sample/gridSample/gridSampleStore.js